import { useSearchParams } from "next/navigation";

// Erstatter den gamle useRouter().query. Henter alle search queries og legger dem inn i et object.
export const useQueryObject = () => {
  const searchParams = useSearchParams();
  if (!searchParams) return {};
  return Object.fromEntries(searchParams.entries());
};
